// extracted by mini-css-extract-plugin
module.exports = {"returnValue":"_1b82d78","returnValueOddsChanged":"_2da19ad","returns":"_83e5f93"};